import { UploadEmployeesTranslation } from '@/assets/locales/views/uploadEmployees/uploadEmployees.translation.en';

export const uploadEmployeesTranslation: UploadEmployeesTranslation = {
  companyScope: {
    cancelButton: 'Anuluj',
    confirmButton: 'Importuj',
    description:
      'Plik obejmuje kilka spółek. JMD importuje się zawsze, zaznacz dodatkowo te spółki, których pracowników chcesz wgrać.',
    mandatoryTag: 'importowana zawsze',
    missingMandatoryCompany:
      'W tym pliku nie ma wierszy spółki JMD. Zaimportują się wyłącznie spółki, które zaznaczysz.',
    readError:
      'Nie udało się odczytać spółek z tego pliku. Sprawdź, czy to plik z danymi pracowników, i spróbuj ponownie.',
    rowCount: 'wiersze: {{rows}}',
    rowsWithoutCompany:
      'Wiersze bez nazwy spółki nigdy nie są importowane. W tym pliku jest ich {{rows}}.',
    title: 'Spółki w pliku',
  },
  companyScopeConfirm: {
    backButton: 'Wróć',
    beyondMandatoryNotice:
      'Pracownicy spoza JMD staną się widoczni w aplikacji, w wyszukiwarce pracowników i w strukturze organizacyjnej.',
    confirmButton: 'Importuj',
    description: 'Import obejmie pracowników tych spółek:',
    missing: {
      deactivateConsent:
        'Dezaktywuj pracowników, których nie ma w pliku ({{count}}) — znikną z aplikacji',
      description:
        'Są aktywni w aplikacji, ale plik już ich nie zawiera, np. bo odeszli z firmy. Bez Twojej zgody import zostawi ich aktywnych.',
      hideList: 'Ukryj listę',
      noName: 'Brak imienia i nazwiska',
      sap: 'SAP {{sap}}',
      showList: 'Pokaż listę',
      title: 'Brak w pliku: {{count}}',
    },
    rowCount: 'wiersze: {{rows}}',
    title: 'Potwierdź zakres importu',
    total: 'Wierszy do zaimportowania: {{rows}}',
  },
  developmentCenterEdition: {
    cancelButton: 'Anuluj',
    confirmButton: 'Importuj',
    description:
      'Plik nie zawiera informacji, jakiego stanowiska i której edycji dotyczy — podaj je tutaj. Razem wyznaczają edycję, pod którą zapiszą się wyniki.',
    editionYearLabel: 'Rok edycji',
    overwriteNotice:
      'Jeśli uczestnik ma już wynik dla tego stanowiska i roku, zostanie nadpisany. Poprzednia wersja zostaje w bazie jako historia.',
    positionNameLabel: 'Stanowisko',
    positionNamePlaceholder: 'np. SSM',
    title: 'Edycja Development Center',
    validation: {
      positionNameRequired: 'Podaj nazwę stanowiska.',
      positionNameTooLong: 'Nazwa stanowiska może mieć maksymalnie 128 znaków.',
      yearOutOfRange: 'Podaj rok z zakresu 2000–{{maxYear}}.',
      yearRequired: 'Podaj rok edycji.',
    },
  },
  fileTypes: {
    CHAT_DOCUMENT: {
      description: 'Dodaje dokument do bazy wiedzy asystenta czatu',
      label: 'Dokument czatu',
    },
    COMPANY_POSITIONS: {
      description: 'Aktualizuje stanowiska firmowe i strukturę organizacyjną',
      label: 'Stanowiska firmowe',
    },
    DEVELOPMENT_ACTIVITIES: {
      description:
        'Importuje aktywności rozwojowe pracowników (np. FRIS, BTM, Coaching) z pliku macierzowego, dopasowując po numerze SAP',
      label: 'Aktywności rozwojowe',
    },
    DEVELOPMENT_CENTER: {
      description:
        'Importuje wyniki sesji Development Center (średnie w kompetencjach i zadaniach, oceny wskaźników, kluczowe wnioski, samoświadomość), dopasowując po numerze SAP. Stanowisko i rok edycji podajesz podczas importu',
      label: 'Development Center',
    },
    EDUAKCJA: {
      description:
        'Zastępuje katalog szkoleń - wiersze dopasowywane po ID obiektu, szkolenia nieobecne w pliku są usuwane',
      label: 'Dane edukacyjne',
    },
    EMPLOYEES: {
      description:
        'Aktualizuje podstawowe informacje o pracownikach (imię, nazwisko, SAP ID, stanowisko, dział)',
      label: 'Pracownicy',
    },
    EMPLOYEES_EMPLOYMENT_HISTORY: {
      description: 'Aktualizuje historie zatrudnienia i ścieżki karier pracowników',
      label: 'Historia zatrudnienia',
    },
    EMPLOYEES_ENABLE_CHANGE: {
      description: 'Aktualizuje status pracowników (aktywny/nieaktywny)',
      label: 'Status pracowników',
    },
    MDR: {
      description: 'Aktualizuje dane MDR (Management Development Review)',
      label: 'Dane MDR',
    },
    SYSTEM_USERS: {
      description: 'Aktualizuje użytkowników systemu i uprawnienia dostępu',
      label: 'Użytkownicy systemu',
    },
  },
  form: {
    downloadFileTemplateLabel: 'Pobierz plik wzorcowy',
    dropzoneLabel: 'Przeciągnij i upuść plik tutaj, lub kliknij aby wybrać plik',
    dropzoneLabel2: '(akceptowane formaty: .xls, .xlsx)',
    fileTypeDescription: 'Co zostanie zaktualizowane:',
    resetButton: 'Resetuj',
    uploadButton: 'Importuj',
    uploadFileLabel: 'Załaduj plik',
    uploadFileType: 'Typ pliku do zaimportowania',
  },
  mdrCareerPathsWarning: {
    cancelButton: 'Anuluj',
    confirmButton: 'Importuj i nadpisz',
    description:
      'Ścieżki kariery pracowników z pliku zostaną zastąpione tymi z pliku. Dotyczy to zarówno profilu pracownika, jak i modułu sukcesji.',
    manualPathsNotice:
      'Ścieżki dodane ręcznie w module sukcesji zostaną dla tych pracowników usunięte. Tej operacji nie można cofnąć.',
    scopeNotice: 'Pracownicy, których nie ma w pliku, pozostaną bez zmian.',
    title: 'Ścieżki kariery zostaną nadpisane',
  },
  modal: {
    closeButton: 'Zamknij',
    downloadErrorButton: 'Pobierz błąd',
    errorOccurred: 'Wystąpił błąd podczas importowania',
    errorTitle: 'Błąd importowania',
    readingCompaniesMessage: 'Sprawdzanie, których spółek dotyczy plik, proszę czekać...',
    readingCompaniesTitle: 'Odczytywanie pliku',
    uploadingMessage: 'Importowanie danych, proszę czekać...',
    uploadingTitle: 'Importowanie danych',
  },
  toast: {
    employeesUploadedFileError:
      'Wystąpił błąd podczas importowania pracowników, załączony plik jest nieprawidłowy',
    employeesUploadedGeneralError:
      'Wystąpił błąd podczas importowania pracowników, spróbuj ponownie później',
    employeesUploadedSuccessfully: 'Pracownicy zostali pomyślnie zaimportowani',
  },
  validationErrors: {
    actions: {
      cancel: 'Anuluj',
      cannotResolveOtherType:
        'Nie można automatycznie rozwiązać błędów typu "Inne" - rozwiąż je pojedynczo',
      chooseEachConflict:
        'Wybierz rozwiązanie przy każdym konflikcie w szczegółach albo pomiń wszystkie',
      close: 'Zamknij',
      closeAndReupload: 'Zamknij i wgraj ponownie',
      continue: 'Kontynuuj',
      replaceFile: 'Podmień plik',
      resolve: 'Rozwiąż',
      resolveAll: 'Rozwiąż wszystkie',
      resolveAllOfType: 'Rozwiąż wszystkie tego typu',
      resolveAllVisible: 'Rozwiąż widoczne',
      skipAllOfType: 'Pomiń wszystkie wiersze tego typu',
      viewDetails: 'Wyświetl szczegóły',
    },
    allErrorsResolvedMessage:
      'Wszystkie błędy walidacji zostały rozwiązane. Możesz teraz kontynuować wgrywanie.',
    allErrorsResolvedTitle: 'Wszystkie błędy rozwiązane',
    businessErrorTypes: {
      BIRTHDAY_DATE_CHANGED: 'Zmiana daty urodzenia',
      COMPANY_POSITION_DATA: 'Dane stanowiska firmowego',
      DEVELOPMENT_CENTER_DERIVED_VALUE_MISMATCH: 'Sumy i liczniki niezgodne z danymi',
      DEVELOPMENT_CENTER_DUPLICATED_SAP: 'Numer SAP powtórzony w pliku',
      DEVELOPMENT_CENTER_INCOMPLETE_ROW: 'Niekompletny wiersz uczestnika',
      DEVELOPMENT_CENTER_INVALID_RATING: 'Ocena spoza dozwolonej skali',
      DEVELOPMENT_CENTER_INVALID_SAP: 'Brak lub błędny numer SAP',
      DEVELOPMENT_CENTER_INVALID_SESSION_DATE: 'Nieprawidłowa data sesji',
      DEVELOPMENT_CENTER_NOT_A_PARTICIPANT: 'Osoba spoza pozostałych etapów certyfikacji',
      DEVELOPMENT_CENTER_PARTICIPANT_NAME_MISMATCH: 'Uczestnik niezgodny z pracownikiem',
      DEVELOPMENT_CENTER_REPORT_MISSING: 'Brak raportu indywidualnego w archiwum',
      DEVELOPMENT_CENTER_REPORT_NO_SAP_PREFIX: 'Nazwa pliku bez numeru SAP',
      DEVELOPMENT_CENTER_REPORT_NOT_A_PDF: 'Plik nie jest dokumentem PDF',
      DEVELOPMENT_CENTER_REPORT_TOO_LARGE: 'Raport przekracza dozwolony rozmiar',
      DEVELOPMENT_CENTER_SCORE_OUT_OF_RANGE: 'Średnia poza skalą',
      DEVELOPMENT_CENTER_UNKNOWN_COMPETENCY: 'Nieznana powiązana kompetencja',
      DEVELOPMENT_CENTER_UNKNOWN_EMPLOYEE: 'Brak pracownika o tym numerze SAP',
      EMPLOYEE_EMAIL_CONFLICT: 'Ten sam adres e-mail u różnych pracowników',
      EMPLOYEE_ENABLE_INVALID_VALUE: 'Nieprawidłowa wartość statusu pracownika',
      EMPLOYEE_POSITION_CONSISTENCY: 'Spójność stanowiska pracownika',
      EMPLOYEE_REQUIRED_FIELDS: 'Brakujące wymagane pola',
      FUNCTIONAL_GROUP_LEVEL_HIERARCHY_INVALID: 'Nieprawidłowa hierarchia poziomu grupy funkcyjnej',
      HRBP_CHANGED: 'Zmiana HRBP',
      OTHER: 'Inne',
      P1_SUPERVISOR_CHANGED: 'Zmiana przełożonego P+1',
      P2_SUPERVISOR_CHANGED: 'Zmiana przełożonego P+2',
      SAP_NUMBER_CHANGED: 'Zmiana numeru SAP',
      SYSTEM_USER_INVALID_ENABLED_VALUE: 'Nieprawidłowa wartość pola aktywności',
    },
    columns: {
      actions: 'Akcje',
      column: 'Kolumna',
      count: 'Liczba',
      errorName: 'Nazwa błędu',
      errorType: 'Typ błędu',
      level: 'Poziom',
      message: 'Komunikat',
      resolution: 'Rozwiązanie',
      row: 'Wiersz',
      severity: 'Poziom',
    },
    criticalErrorMessage:
      'Plik zawiera błędy strukturalne (np. brakujące kolumny) i nie może zostać przetworzony. Wymagane jest poprawienie pliku i ponowne wgranie.',
    criticalErrorsFound: 'Znaleziono błędy krytyczne',
    criticalErrorTitle: 'Błąd krytyczny walidacji',
    detailsTitle: 'Szczegóły błędów',
    goToPage: 'Przejdź do strony',
    noErrors: 'Brak błędów',
    replaceFileDialog: {
      acceptedFormats: '(akceptowane formaty: .xls, .xlsx)',
      description: 'Wgraj nowy plik, aby podmienić obecny. Walidacja rozpocznie się od nowa.',
      dropzoneLabel: 'Przeciągnij i upuść plik tutaj, lub kliknij aby wybrać plik',
      title: 'Podmień plik',
      uploadButton: 'Wgraj',
    },
    resolution: {
      options: {
        ACCEPT_SAP_NUMBER: 'Przypisz pracownikowi nowy numer SAP',
        KEEP_SAP_NUMBER: 'Zostaw wiersz z numerem SAP {{value}}',
        SKIP_ROW: 'Pomiń w imporcie',
      },
      placeholder: 'Wybierz rozwiązanie',
      recommended: 'Polecane',
      saveFailed: 'Nie udało się zapisać wyboru. Spróbuj ponownie.',
    },
    skippedRowsMessage: 'Wiersze, które nie zostaną zaimportowane po kontynuacji: {{rows}}.',
    skippedRowsTitle: 'Część wierszy zostanie pominięta',
    status: {
      resolved: 'Rozwiązany',
    },
    subtitle: 'Przejrzyj i rozwiąż błędy wykryte podczas walidacji pliku',
    summaryTitle: 'Podsumowanie błędów wg typu',
    title: 'Błędy walidacji',
    uploadInfo: {
      fileName: 'Nazwa pliku',
      fileType: 'Typ pliku',
      title: 'Informacje o pliku',
      uploadDate: 'Data wgrania',
    },
    validationInfoMessage:
      'Plik zawiera błędy walidacji. Możesz rozwiązać błędy w systemie lub poprawić plik i wgrać go ponownie.',
    validationInfoTitle: 'Informacja o walidacji',
  },
};
